import { useState } from 'react';

import Search from 'assets/filters/searchIcon.svg';
import Configure from 'assets/unifiedCommunication/Configure.svg';
import Input from 'common-ui/input';
import MyCheckbox from 'common-ui/myCheckbox';
import Switch from 'common-ui/switch';
import { Table } from 'common-ui/table';

import ChannelConfigurator from '../components/ChannelConfigurator';
import {
  ConfigureButton,
  InputWrapper,
  StatusWrapper,
  TableContainer,
} from './ByTeam.styles.js';

const ByTeam = () => {
  const initialData = [
    { id: 1, team: 'Team Alpha', viewAccess: false, viewReply: false, status: 'Active' },
    { id: 2, team: 'Team Beta', viewAccess: true, viewReply: true, status: 'Active' },
    { id: 3, team: 'Team Gamma', viewAccess: false, viewReply: true, status: 'Disabled' },
  ];

  const [tableData, setTableData] = useState(initialData);
  const [isChannelModalOpen, setIsChannelModalOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [channelPermissions, setChannelPermissions] = useState({});

  const handleToggleStatus = (id) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, status: item.status === 'Active' ? 'Disabled' : 'Active' }
          : item
      )
    );
  };

  const handleCheckboxChange = (rowId, field, selectedOption) => {
    setTableData((prev) =>
      prev.map((item) =>
        item.id === rowId
          ? { ...item, [field]: selectedOption === 'all' ? false : !item[field] }
          : item
      )
    );
  };

  const columns = [
    {
      key: 'team',
      title: 'Team Name',
      dataIndex: 'team',
      render: (value) => <span>{value}</span>,
    },
    {
      key: 'viewAccess',
      title: 'View Access',
      dataIndex: 'viewAccess',
      render: (value, row) => (
        <MyCheckbox
          id={`viewAccess-${row.id}`}
          selected={value}
          onClick={(option) => handleCheckboxChange(row.id, 'viewAccess', option)}
        />
      ),
    },
    {
      key: 'viewReply',
      title: 'View and Reply',
      dataIndex: 'viewReply',
      render: (value, row) => (
        <MyCheckbox
          id={`viewReply-${row.id}`}
          selected={value}
          onClick={(option) => handleCheckboxChange(row.id, 'viewReply', option)}
        />
      ),
    },
    {
      key: 'channels',
      title: 'Channels',
      dataIndex: 'channels',
      render: (_value, row) => (
        <ConfigureButton
          onClick={() => {
            setSelectedTeam(row);
            setIsChannelModalOpen(true);
          }}
        >
          <img src={Configure} alt="configure" />
          Configure
        </ConfigureButton>
      ),
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (value, row) => {
        const isActive = value === 'Active';
        const textColor = isActive ? '#15C7A7' : '#62748E';
        return (
          <StatusWrapper>
            <p>{value}</p>
            <Switch
              activeColor="#15C7A7"
              isOn={isActive}
              onToggle={() => handleToggleStatus(row.id)}
            />
          </StatusWrapper>
        );
      },
    },
  ];

  return (
    <div>
      <InputWrapper>
        <Input label="Search Team name" leftIcon={Search} />
      </InputWrapper>

      <TableContainer>
        <Table data={tableData} columns={columns} pagination={false} />
      </TableContainer>

      <ChannelConfigurator
        isOpen={isChannelModalOpen}
        onClose={() => setIsChannelModalOpen(false)}
        team={selectedTeam}
        channelPermissions={channelPermissions}
        setChannelPermissions={setChannelPermissions}
      />
    </div>
  );
};

export default ByTeam;
